export const STORAGE_KEYS = {
  token: 'flowe_token',
  studioId: 'flowe_studio_id',
  impersonationToken: 'flowe_impersonation_token',
  impersonationExpiresAt: 'flowe_impersonation_expires_at',
  impersonationStudioId: 'flowe_impersonation_studio_id',
  impersonationStudioName: 'flowe_impersonation_studio_name',
  impersonationAdminToken: 'flowe_impersonation_admin_token',
  impersonationReturnPath: 'flowe_impersonation_return_path',
} as const
